import React from 'react';
import styles from './news.module.scss';
import BioImage from 'static/images/bio.png';
import UserImage from 'static/images/media-person.jpg';

const Bio = ({ bio }) => (
  <div className={styles.bio}>
    <h2>CORPORATE BIO</h2>
    <div className={styles.bioImage}>
      <img src={BioImage} alt="bio" />
      <div>
        <p>David Gooding</p>
        <span>President</span>
      </div>
    </div>
    <div className={styles.link}>
      <a href={bio} target="_blank" rel="noreferrer">
        Download Bio
      </a>
      <a href={UserImage} target="_blank" rel="noreferrer">
        Download Photo
      </a>
    </div>
  </div>
);

export default Bio;
